<template>
    <div class="testimonial-slider-content m-auto">
        <carousel :items-to-show="1" :auto-height="true" :wrapAround="true" :autoplay="false" snapAlign="start">

            <slide v-for="(slide, i) in items" :key="i" class="testimonial-slider-item">
                <div class="testimonial-slider-item-inner position-relative d-flex align-center">
                    <div class="testimonial-slider-image position-relative">
                        <img class="w-full" :src="slide.image" :alt="slide.name">
                    </div>
                    <div class="testimonial-slider-body text-left">
                        <h3 class="name">{{slide.name}}</h3>
                        <span class="designation">{{slide.designation}}</span>
                        <p>{{slide.content}}</p>
                    </div>
                </div>
            </slide>

            <template #addons>
                <pagination />
            </template>
        </carousel>
    </div>
</template>

<script>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination } from 'vue3-carousel';

export default {
    name: 'TestimonialSlider',
    props: ['items'],
    components: {
        Carousel,
        Slide,
        Pagination,
    }
}
</script>